import { render } from "./notificationComponent.vue?vue&type=template&id=6b0d3c76"
import script from "./notificationComponent.vue?vue&type=script&lang=js"
export * from "./notificationComponent.vue?vue&type=script&lang=js"

import "./notificationComponent.vue?vue&type=style&index=0&id=6b0d3c76&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__